class GreenWayStopsApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    name}) {
    return {
      name,
    };
  }
}

export default GreenWayStopsApiResponseModel;
